import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_RESPONSAVEIS_ASSINATURA = `${modulo.ASSINATURA}/responsaveis`

const actions = {

  async getResponsaveis ({ commit }) {
    const data = await axios({
      method: 'get',
      url: `${URL_RESPONSAVEIS_ASSINATURA}`
    })

    return data
  },

  getResponsaveisNaoAssinaram ({ commit }, idDocumento) {
    return axios({
      method: 'get',
      url: `${URL_RESPONSAVEIS_ASSINATURA}/naoAssinaram?idDocumento=${idDocumento}`
    })
  },

  getResponsavel ({ commit }) {
    return axios({
      method: 'get',
      url: `${URL_RESPONSAVEIS_ASSINATURA}/usuario`
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/assinatura/responsavel.js